
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';;
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

import { UserQueryService, RolesQueryService } from '../queryFiles/index';

@Injectable()
export class AuthService implements Resolve<any>
{

    onCurrentUserChanged: BehaviorSubject<any> = new BehaviorSubject('');

    constructor(
        public userQueryService: UserQueryService,
        public rolesQueryService: RolesQueryService
    ) {
    }

    /**
     * The Academy App Main Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {

            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /** Get current User details */
    GetUserById() {

        return new Promise((resolve, reject) => {
            this.userQueryService
                .GET_CURRENT_USER()
                .subscribe((res: any) => {

                    var responseData = res.data &&
                        res.data.allUsers &&
                        res.data.allUsers.edges[0].node;
                    this.onCurrentUserChanged.next(responseData);

                    resolve('success');
                }, err => {
                    reject(err);
                });
        });
    }

    /**Get Role Id of selected role */
    getRoleId(roleName) {

        return new Promise((resolve, reject) => {

            this.rolesQueryService
                .GET_ROLE_ID_BY_ROLE_NAME(roleName)
                .valueChanges
                .subscribe((response: any) => {

                    response.data.allRoles.edges.forEach((role, key) => {

                        if (role.hasOwnProperty('node')) {
                            resolve(role.node.roleId);
                        } else {
                            reject('error');
                        }

                    })

                })
        })

    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/authentication/auth.service.ts